import { render, staticRenderFns } from "./PersistentSearch.vue?vue&type=template&id=37bce3d1&scoped=true&"
import script from "./PersistentSearch.vue?vue&type=script&lang=js&"
export * from "./PersistentSearch.vue?vue&type=script&lang=js&"
import style0 from "./PersistentSearch.vue?vue&type=style&index=0&id=37bce3d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bce3d1",
  null
  
)

export default component.exports